// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExperimentOutlinedSvg from "@ant-design/icons-svg/es/asn/ExperimentOutlined";
import AntdIcon from '../components/AntdIcon';

var ExperimentOutlined = function ExperimentOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentOutlinedSvg
  }));
};

ExperimentOutlined.displayName = 'ExperimentOutlined';
export default React.forwardRef(ExperimentOutlined);